export enum ParamKeyEnum {
  InviteToken = 'inviteToken',
  SpaceToken = 'spaceToken',
  InitialState = 'initState',
}
